var exports = {
  "b": "xcc377c0b--fd2c37--page-row-item",
};

module.exports = exports;
